import { Utils } from 'formiojs';
import { form as template } from 'src/formio/templates/file/form';

const compiledForm = Utils.Evaluator.template(template, 'file-component');
export const formioFileComponentCustomTemplate = (ctx: any) => {
    return compiledForm(ctx);
};
